import { render, staticRenderFns } from "./collectVideoList.vue?vue&type=template&id=d82ba838&scoped=true"
import script from "./collectVideoList.vue?vue&type=script&lang=js"
export * from "./collectVideoList.vue?vue&type=script&lang=js"
import style0 from "./collectVideoList.vue?vue&type=style&index=0&id=d82ba838&prod&scoped=true&lang=css"
import style1 from "./collectVideoList.vue?vue&type=style&index=1&id=d82ba838&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d82ba838",
  null
  
)

export default component.exports